<agr-page-toolbar [pageTitle]="'app.customer.navigation.details' | translate"></agr-page-toolbar>
<section class="spacing--padding-all" data-test="customer-detail">
  <form [formGroup]="form" [agrConnectForm]="details$" (ngSubmit)="save()">
    <div class="form-field-wrapper">
      <div class="text--h5">{{ 'app.customer.detail.title_general' | translate }}</div>
      @if ((routeUrl$ | async) !== '/customer/add') {
        <mat-form-field class="flex__child--auto">
          <input
            matInput
            readonly
            inputmode="numeric"
            placeholder="{{ 'app.customer.detail.id' | translate }}"
            formControlName="id"
            data-test="customer-detail__id"
          />
        </mat-form-field>
      }

      <mat-form-field class="flex__child--auto">
        <input
          matInput
          inputmode="text"
          placeholder="{{ 'app.customer.detail.name' | translate }}"
          formControlName="name"
          data-test="customer-detail__name"
        />
        @if (form.controls.name.invalid) {
          <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
        }
      </mat-form-field>

      <div class="text--h5">{{ 'app.customer.detail.title_address' | translate }}</div>
      <mat-form-field class="flex__child--auto">
        <input
          matInput
          inputmode="text"
          placeholder="{{ 'app.customer.detail.street' | translate }}"
          formControlName="street"
          data-test="customer-detail__street"
        />
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <input
          matInput
          inputmode="text"
          placeholder="{{ 'app.customer.detail.postal_code' | translate }}"
          formControlName="postalCode"
          data-test="customer-detail__postal-code"
        />
      </mat-form-field>

      <div class="flex--row flex--gutter">
        <mat-form-field class="flex__child--auto">
          <input
            matInput
            agrNumber
            placeholder="{{ 'app.customer.detail.house_number' | translate }}"
            formControlName="houseNumber"
            data-test="customer-detail__house-number"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <input
            matInput
            inputmode="text"
            placeholder="{{ 'app.customer.detail.house_number_addition' | translate }}"
            formControlName="houseNumberAddition"
            data-test="customer-detail__house-number-addition"
          />
        </mat-form-field>
      </div>

      <div class="flex--row flex--gutter">
        <mat-form-field class="flex__child--auto">
          <input
            matInput
            inputmode="text"
            placeholder="{{ 'app.customer.detail.city' | translate }}"
            formControlName="city"
            data-test="customer-detail__city"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'app.customer.detail.country' | translate }}</mat-label>
          <mat-select formControlName="country" data-test="customer-detail__country">
            <mat-option>-</mat-option>
            @for (country of countries; track country) {
              <mat-option [value]="country.countryCode">
                {{ 'app.countries.' + country.countryCode | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="text--h5">{{ 'app.customer.detail.title_contact' | translate }}</div>
      <mat-form-field class="flex__child--auto">
        <input
          matInput
          type="email"
          placeholder="{{ 'app.customer.detail.email_address' | translate }}"
          formControlName="emailAddress"
          data-test="customer-detail__email-address"
        />
        @if (form.controls.emailAddress.errors?.required) {
          <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
        }
        @if (form.controls.emailAddress.errors?.email) {
          <mat-error>{{ 'app.errormsg.email_pattern' | translate }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <input
          matInput
          inputmode="text"
          placeholder="{{ 'app.customer.detail.phone_number' | translate }}"
          formControlName="phoneNumber"
          data-test="customer-detail__phone-number"
        />
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <input
          matInput
          inputmode="text"
          placeholder="{{ 'app.customer.detail.mobile_number' | translate }}"
          formControlName="mobileNumber"
          data-test="customer-detail__mobile-number"
        />
      </mat-form-field>

      <div class="spacing--margin-top mat-button-row">
        <button
          type="submit"
          mat-flat-button
          class="flex__child"
          color="primary"
          data-test="customer-detail__save"
        >
          {{ 'save' | translate }}
        </button>
      </div>
    </div>
  </form>
</section>
